<template>
<div class="modal-user">
	<div class="container-select-subsidiary"> 
		<div class="section">
			<p class="label-title">Seleccione las Sucursales</p>
			<div class="container-user">
			<v-checkbox
				class="block-checkbox"
				label="Seleccionar todos"
				hide-details
				v-model="allSubsidiary"
				@change="selectAll('subsidiaries', subsidiaries, allSubsidiary)"
			></v-checkbox>
			<v-checkbox
				class="block-checkbox"
				hide-details
				v-for="(subsidiary, indexSub) in subsidiaries"
				:key="indexSub"
				:label="subsidiary.sucursal_name"
				v-model="subsidiary.isSelected"
			></v-checkbox>
			<div class="container-btn">
      	<v-btn
          type="button"
					class="btn-save btn-save-form"
					@click.native="updateSubsidiary">Aceptar</v-btn>
          <v-btn
          type="button"
					class="btn__content btn-save-form" 
					@click="$emit('close-modal')">Cancelar</v-btn>
      </div>
		</div>
		</div>    
  </div>
</div>
</template>

<script>
import lib from '@/shared/lib';

const { map, setNewProperty } = lib;

function data() {
	return {
		newObject: {
			id: '',
			sucursal_name: '',
			subsidiariesId: '',
		},
		isSelected: '',
		allSubsidiary: false,
		subsidiaries: [],
		user: {
			checked: '',
		},
	};
}

function created() {
	this.loadHotels();
}

async function updateSubsidiary() {
	try {
		const dateSubsidiary = this.subsidiaries;
		const body = {
			name: this.row.name,
			numDocument: this.row.dni,
			email: this.row.email,
			subsidiaries: dateSubsidiary,
		};
		await this.$http.put(`${process.env.PMS_URL}/employees/${this.row.id}`, body);
		this.$emit('close-modal');
	} catch (error) {
		this.showNotification('Error');
	}
}

async function loadHotels() {
	const { data: response } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = response.data;
	const subsidiary = this.row.subsidiaries;
	const subUser = this.subsidiaries.map((r) => {
		const subsidiaryHotel = {};
		const prue = subsidiary.find(sub => sub.id === r.id);
		if (prue) {
			subsidiaryHotel.isSelected = prue.isSelected;
		} else {
			subsidiaryHotel.isSelected = false;
		}
		subsidiaryHotel.id = r.id;
		subsidiaryHotel.sucursal_name = r.name;
		return subsidiaryHotel;
	});
	this.subsidiaries = subUser;
}

function selectAll(name, collection, value) {
	this[name] = map(setNewProperty('isSelected', value), collection);
}

export default {
	name: 'modal-user',
	data,
	created,
	props: {
		row: {
			default: () => {},
			type: [Array, Object],
		},
	},
	methods: {
		updateSubsidiary,
		loadHotels,
		selectAll,
	},
};
</script>

<style lang="scss" scoped>
.subsidiaries-grid {
	align-content: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.modal-user {
	align-items: center;
	display: flex;
	height: 100%;
	justify-content: center;
	position: relative;
	width: 100%;
}

.label-title {
  font-family: "San Francisco Display Medium";
	font-size: 18px;
	margin-bottom: 10px;
}

.container-select-subsidiary {
	align-items: center;
	background: rgba(0, 0, 0, 0.42);
	bottom: 0;
	content: '';
	display: flex;
	height: 100%;
	justify-content: center;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	width: 100%;
}

.section {
	background: #efefef;
	height: 330px;
	padding: 20px;
	width: 350px;
}

.btn {
	height: 35px;
	max-width: 150px;
}

.container-btn {
	display: flex;
	justify-content: space-around;
	margin-top: 35px;
}
</style>



// WEBPACK FOOTER //
// modal-user.vue?99c3713a